import type { EdgeDescriptor } from '@bliks-io/ui';
import { canPerformEdgeAction } from './capabilities';
import { performDisconnect } from './disconnect';
import { performForkFromSource } from './forkFromSource';
import { performInsertBetween } from './insertBetween';
import { performMarkUnclear } from './markUnclear';
import { performMergeIntoTarget } from './mergeIntoTarget';
import type { EdgeAction, EdgeActionDeps } from './types';

export async function performEdgeAction(
  action: EdgeAction,
  edge: EdgeDescriptor,
  deps: EdgeActionDeps
): Promise<void> {
  if (!canPerformEdgeAction(action, edge)) return;
  switch (action) {
    case 'disconnect':
      await performDisconnect(edge, deps);
      return;
    case 'forkFromSource':
      await performForkFromSource(edge, deps);
      return;
    case 'mergeIntoTarget':
      await performMergeIntoTarget(edge, deps);
      return;
    case 'insertBetween':
      await performInsertBetween(edge, deps);
      return;
    case 'markUnclear':
      await performMarkUnclear(edge, deps);
      return;
  }
}
